export default __webpack_public_path__ + "static/media/EngineeringBridges_00.731eb541.png";